import "./About.css";

function About() {
  return (
    <>

      {/* ==========================
            ABOUT HERO
      ========================== */}

      <section
        className="cc-about-hero"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1920&q=80')",
        }}
      >

        <div className="cc-about-overlay">

          <div className="cc-about-hero-content">

            <h1>
              About InteriorMart
            </h1>

            <p>
              Home / About Us
            </p>

          </div>

        </div>

      </section>

      {/* ==========================
          ABOUT COMPANY
      ========================== */}

      <section className="cc-about-company">

        <div className="cc-about-company-left">

          <img
            src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=900&q=80"
            alt=""
          />

        </div>

        <div className="cc-about-company-right">

          <span>
            ABOUT COMPANY
          </span>

          <h2>
            We Help People Find Their Perfect Property
          </h2>

          <p>

            InteriorMart is a modern real estate platform
            designed to connect buyers, sellers and agents.
            We make property searching simple, secure and
            transparent with advanced technology.

          </p>

          <p>

            Whether you're searching for your dream home,
            commercial property or investment opportunity,
            our experienced team ensures a smooth and
            trustworthy experience.

          </p>

          <div className="cc-about-info-box">

            <div>

              <h3>10+</h3>

              <p>Years Experience</p>

            </div>

            <div>

              <h3>25K+</h3>

              <p>Properties Listed</p>

            </div>

            <div>

              <h3>15K+</h3>

              <p>Happy Clients</p>

            </div>

          </div>

        </div>

      </section>

      {/* ==========================================
        WHY CHOOSE US
========================================== */}

<section className="cc-about-why">

    <div className="cc-about-why-heading">

        <span>WHY CHOOSE US</span>

        <h2>
            Why Thousands of Customers Trust
            InteriorMart
        </h2>

        <p>

            We simplify property buying, selling and renting
            through verified listings, experienced agents and
            exceptional customer support.

        </p>

    </div>

    <div className="cc-about-why-grid">

        {/* CARD 1 */}

        <div className="cc-about-why-card">

            <div className="cc-about-why-icon">

                🏡

            </div>

            <h3>
                Premium Properties
            </h3>

            <p>

                Explore luxury apartments, villas,
                commercial spaces and investment
                properties across India.

            </p>

        </div>

        {/* CARD 2 */}

        <div className="cc-about-why-card">

            <div className="cc-about-why-icon">

                🤝

            </div>

            <h3>
                Trusted Agents
            </h3>

            <p>

                Work with experienced professionals
                who guide you through every step
                of your property journey.

            </p>

        </div>

        {/* CARD 3 */}

        <div className="cc-about-why-card">

            <div className="cc-about-why-icon">

                💰

            </div>

            <h3>
                Best Price Guarantee
            </h3>

            <p>

                Get competitive prices with complete
                transparency and no hidden charges.

            </p>

        </div>

        {/* CARD 4 */}

        <div className="cc-about-why-card">

            <div className="cc-about-why-icon">

                ⭐

            </div>

            <h3>
                Customer Satisfaction
            </h3>

            <p>

                Our dedicated support team ensures
                every customer receives outstanding
                service and guidance.

            </p>

        </div>

    </div>

</section>



{/* ==========================================
            COMPANY STATISTICS
========================================== */}

<section className="cc-about-counter">

    <div className="cc-about-counter-box">

        <h2>25K+</h2>

        <p>Properties Listed</p>

    </div>

    <div className="cc-about-counter-box">

        <h2>15K+</h2>

        <p>Happy Clients</p>

    </div>

    <div className="cc-about-counter-box">

        <h2>850+</h2>

        <p>Expert Agents</p>

    </div>

    <div className="cc-about-counter-box">

        <h2>10+</h2>

        <p>Years Experience</p>

    </div>

</section>

{/* ==========================================
            OUR TEAM
========================================== */}

<section className="cc-about-team">

    <div className="cc-about-team-heading">

        <span>OUR TEAM</span>

        <h2>
            Meet Our Professional Agents
        </h2>

        <p>
            Our experienced real estate experts are committed
            to helping you find the perfect property with
            honesty, professionalism and exceptional service.
        </p>

    </div>

    <div className="cc-about-team-grid">

        {/* Member 1 */}

        <div className="cc-about-team-card">

            <img
                src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=800&q=80"
                alt=""
            />

            <div className="cc-about-team-content">

                <h3>Michael Johnson</h3>

                <span>Senior Property Consultant</span>

                <div className="cc-about-team-social">

                    <a href="/"><i className="fa-brands fa-facebook-f"></i></a>

                    <a href="/"><i className="fa-brands fa-instagram"></i></a>

                    <a href="/"><i className="fa-brands fa-linkedin-in"></i></a>

                </div>

            </div>

        </div>

        {/* Member 2 */}

        <div className="cc-about-team-card">

            <img
                src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=800&q=80"
                alt=""
            />

            <div className="cc-about-team-content">

                <h3>Emma Wilson</h3>

                <span>Sales Manager</span>

                <div className="cc-about-team-social">

                    <a href="/"><i className="fa-brands fa-facebook-f"></i></a>

                    <a href="/"><i className="fa-brands fa-instagram"></i></a>

                    <a href="/"><i className="fa-brands fa-linkedin-in"></i></a>

                </div>

            </div>

        </div>

        {/* Member 3 */}

        <div className="cc-about-team-card">

            <img
                src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=800&q=80"
                alt=""
            />

            <div className="cc-about-team-content">

                <h3>David Smith</h3>

                <span>Property Advisor</span>

                <div className="cc-about-team-social">

                    <a href="/"><i className="fa-brands fa-facebook-f"></i></a>

                    <a href="/"><i className="fa-brands fa-instagram"></i></a>

                    <a href="/"><i className="fa-brands fa-linkedin-in"></i></a>

                </div>

            </div>

        </div>

        {/* Member 4 */}

        <div className="cc-about-team-card">

            <img
                src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=800&q=80"
                alt=""
            />

            <div className="cc-about-team-content">

                <h3>Sophia Brown</h3>

                <span>Marketing Head</span>

                <div className="cc-about-team-social">

                    <a href="/"><i className="fa-brands fa-facebook-f"></i></a>

                    <a href="/"><i className="fa-brands fa-instagram"></i></a>

                    <a href="/"><i className="fa-brands fa-linkedin-in"></i></a>

                </div>

            </div>

        </div>

    </div>

</section>



{/* ==========================================
            CALL TO ACTION
========================================== */}

<section
className="cc-about-cta"
style={{
backgroundImage:"url('https://images.unsplash.com/photo-1560185008-b033106af5c3?auto=format&fit=crop&w=1920&q=80')"
}}
>

<div className="cc-about-cta-overlay">

<h2>
Ready To Find Your Dream Property?
</h2>

<p>
Browse thousands of verified listings and connect with
trusted real estate professionals today.
</p>

<button>
Explore Properties
</button>

</div>

</section>

    </>
  );
}

export default About;